import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./common/locales/i18n";
import "./globals.css";
import { App } from "./app";

// After a deploy, an already-open tab still references the previous build's
// hashed chunks; the first lazy route it visits then fails to fetch. Vite
// emits vite:preloadError for exactly that case — reload once to pick up the
// new build instead of surfacing a dead error screen.
window.addEventListener("vite:preloadError", (event) => {
	const key = "chunk-reload-at";
	const last = Number(sessionStorage.getItem(key) ?? 0);
	if (Date.now() - last < 10_000) return;
	sessionStorage.setItem(key, String(Date.now()));
	event.preventDefault();
	window.location.reload();
});

// biome-ignore lint/style/noNonNullAssertion: root is always defined
createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
